<template>
  <div>
    <!-- TODO fix scroll-to-top button -->
    <ul class="sidebar" v-if="sidebarLinks.length > 1">
      <a v-for="(link, index) in sidebarLinks"
         class="sidebar__link"
         :key="index" :href="'#' + link">
        {{ link }}
      </a>
    </ul>
    <section v-for="(document, documentTypeAsKey) in documents"
             :key="documentTypeAsKey"
             :id="documentTypeAsKey">
      <h2 v-if="document.length !== 0" class="header">{{ documentTypeAsKey }}</h2>
      <ul>
        <li v-for="(doc, index) in document" :key="index" class="doc-item">
          <p class="doc-title">
            <text-highlight :queries="keywords">{{ doc.displayName }}</text-highlight>
          </p>
          <!-- <router-link class="doc-link" :to="'/' + documentTypeAsKey +'/' +doc.index"> -->
          <router-link class="doc-link" :to="{name: getNamedRouteByDocumentType(documentTypeAsKey), 
            params: getLinkParms(doc.index,documentTypeAsKey) 
          }">
            View detail
            <font-awesome-icon icon="arrow-right"/>
          </router-link>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
import {
  CdasNavigation,
  ReportsNavigation,
  PdfNavigation
} from '@/store/modules/fsm/messages';

import { 
  CDA_FILE_TYPE,
  PDF_FILE_TYPE,
  REPORT_FILE_TYPE
} from "@/config";

export default {
  name: "SearchDocumentResults",
  props: {
    documents: Object,
    keywords: Array,
  },
  computed: {
    sidebarLinks: function () {
      let links = [];
      Object.keys(this.documents).forEach((key, index) => {
        if (this.documents[key].length !== 0) {
          links.push(key);
        }
      });
      return links;
    },
  },
  methods: {
    getLinkParms(index,documentTypeAsKey) {
      let result = {
        fileType
      };
      switch(documentTypeAsKey) {
        case 'cdas':
          result.index = index;
          break;
        case 'reports':
          result.selectedReport = index;
          break;
        case 'pdfs':
          result.selectedPdf = index;
          break;
      }
      return result;
    },
    getNamedRouteByDocumentType(documentType) {
      switch (documentType) {
        case 'cdas':
          return CdasNavigation;
        case 'reports':
          return ReportsNavigation;
        case 'pdfs':
          return PdfsNavigation;
        default:
          break;
      }
    },
    getFileType(documentType) {
      switch (documentType) {
        case 'cdas':
          return CDA_FILE_TYPE;
        case 'reports':
          return REPORT_FILE_TYPE;
        case 'pdfs':
          return PDF_FILE_TYPE;
        default:
          break;
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../stylesheets/mixins/flex";

$color-font: #58595b;

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
h2 {
  font-size: 1.5em;
  color: $color-font;
}
p {
  margin: 0;
}
a {
  /*color: #000*/
}
.header {
  text-align: center;
  margin-top: 0.5em;
}
.doc-item {
  @include flex-box();
  @include flex-wrap(wrap);
  /*margin: 0.5em 0;*/
  padding: 0.75em 0.5em;
  &:nth-child(odd) {
    background-color: #ececec;
  }
}
.doc-title {
  @include flex(1, 0, 80%);
}
.doc-link {
  @include flex(1, 0, 10%);
}

.sidebar__link {
  font-size: 0.85em;
  border: 1px solid rgba(0, 0, 0, 0.15);
  padding: 0.25em 1.5em;
}

</style>